import { JSX } from "react";
import { useIntl } from "react-intl";
import { ValueSkeleton } from "../skeletons";
import { formatNumberLocale } from "@/utils/helpers";

type Props = {
  blockchainData: any;
  darkMode: boolean;
}

/**
 * Displays the wallet balance when the entity has a public key.
 */
function Wallet({ blockchainData }: Props): JSX.Element {
  const intl = useIntl();

  if (!blockchainData.hasPublicKey) {
    return <div />;
  }

  return (
    <div className="flex items-center gap-x-1">
      <div className="mx-1 items-center flex text-xs md:text-lg text-gray-800 dark:text-gray-100">
        {
          blockchainData.loading ?
            <ValueSkeleton className="min-w-[100px] max-h-[20px]" /> :
            formatNumberLocale(intl, blockchainData.balance, "decimal", false, false, true)
        }
      </div>
    </div>
  );
}

export default Wallet;
